export { default, Icon } from '../components/icon';
export { IconFacade as UNSAFE_IconFacade } from '../components/icon-facade';